import { useState } from 'react';
import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Routes from 'routes';
import ThemeCustomization from 'themes';
import { AuthProvider } from 'contexts/AuthContext';

const App = () => {
  const [queryClient] = useState(() => new QueryClient({ defaultOptions: { queries: { retry: 1 } } }));

  return (
    <ThemeCustomization>
      {/* English only; the filter labels carry their own defaultMessage. */}
      <IntlProvider locale="en" defaultLocale="en" messages={{}} onError={() => {}}>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <AuthProvider>
              <Routes />
            </AuthProvider>
          </SnackbarProvider>
        </QueryClientProvider>
      </IntlProvider>
    </ThemeCustomization>
  );
};

export default App;
